import { type SizeKeys, type Sizes, size } from "../token-size";

const spaces = Object.entries(size).map(([k, v]) => {
  return [k, sizeToSpace(v)] as const;
});

// a bit odd but keeping backward compat for values >8 while fixing below
function sizeToSpace(v: number) {
  if (v === 0) {
    return 0;
  }
  if (v === 2) {
    return 0.5;
  }
  if (v === 4) {
    return 1;
  }
  if (v === 8) {
    return 1.5;
  }
  if (v <= 16) {
    return Math.round(v * 0.333);
  }
  return Math.floor(v * 0.7 - 12);
}

// Generate negative space tokens for all size keys
// - Legacy keys ($4) → -4 (strip $ prefix)
// - New keys (si4) → -si4 (keep full name)
const spacesNegative = spaces
  .filter(([k]) => k !== "$0" && k !== "si0") // Skip zero values
  .map(([k, v]) => {
    const negativeKey = k.startsWith("$") ? `-${k.slice(1)}` : `-${k}`;
    return [negativeKey, -v];
  });

// Generate negative types for all size keys
// - Legacy keys: 4 → -4
// - New keys: si4 → -si4
type SizeKeysWithNegatives = Exclude<`-${SizeKeys}`, "-0" | "-si0"> | SizeKeys;

export const spaceLegacy: {
  [Key in SizeKeysWithNegatives]: Key extends keyof Sizes ? Sizes[Key] : number;
} = {
  ...Object.fromEntries(spaces),
  ...Object.fromEntries(spacesNegative),
};

/**
 * @deprecated Use `SpaceTokensKeys` instead
 */
export type SpaceLegacyKeys = keyof typeof spaceLegacy;
